import { ROLES } from '@/shared/constants/roles';

export const widgetRoutes = [
  {
    path: '/sharedchat/:chatId',
    name: 'sharedchat',
    component: () => import('./views/WidgetSharedChatView.vue'),
    meta: { public: true },
  },
  {
    path: '/widget-shared/:chatId',
    name: 'widget-shared-chat',
    component: () => import('./views/WidgetSharedChatView.vue'),
    meta: { public: true },
  },
  {
    path: '/widget-courses',
    name: 'widget-courses',
    component: () => import('./views/WidgetCoursesView.vue'),
    meta: { requiredRole: ROLES.INSTITUTION_ADMIN },
  },
];
